
import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/reports/region_report';
import List from './List';

const ms2p = (state) => {
    return {
        ...state.region_report,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(List);
